import { render, staticRenderFns } from "./StepTwoUpload.vue?vue&type=template&id=3d055e48&"
import script from "./StepTwoUpload.vue?vue&type=script&lang=js&"
export * from "./StepTwoUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports